/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const PlayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="PlayIcon">
      <path
        d="M8 15.5C3.85775 15.5 0.5 12.1423 0.5 8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5ZM8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM6.9665 5.31125L10.6258 7.75025C10.6669 7.77764 10.7006 7.81476 10.724 7.85834C10.7473 7.90191 10.7595 7.95057 10.7595 8C10.7595 8.04943 10.7473 8.09809 10.724 8.14166C10.7006 8.18524 10.6669 8.22236 10.6258 8.24975L6.96575 10.6888C6.92062 10.7187 6.86824 10.7358 6.81415 10.7384C6.76007 10.7409 6.7063 10.7288 6.65856 10.7033C6.61081 10.6777 6.57086 10.6398 6.54294 10.5934C6.51503 10.547 6.50019 10.4939 6.5 10.4398V5.56025C6.5001 5.50599 6.51492 5.45277 6.54287 5.40626C6.57082 5.35975 6.61086 5.3217 6.65873 5.29615C6.7066 5.2706 6.76051 5.25851 6.8147 5.26117C6.8689 5.26383 6.92136 5.28113 6.9665 5.31125Z"
        fill="currentColor"
      />
    </svg>)
  );
};

export default PlayIcon;
